<template>
  <v-card>
    <Snackbar :textError="textError" :isSnackbar="isSnackbar" />
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="this.headers"
      :items="this.dataValue"
      :search="search"
      :items-per-page="20"
      :footer-props="{
        'items-per-page-text': 'Filas por página',
        'items-per-page-options': [20, 30, 50, 100, -1],
      }"
      :custom-filter="dataTableCustomSearch"
    >
      <template v-slot:item.evaluator="{ item }">
        <span>{{ getEvaluator(item.evaluator) }}</span>
      </template>
      <template v-slot:item.promoter="{ item }">
        <span>{{ getPromoter(item.promoter) }}</span>
      </template>
      <template v-slot:item.supplier="{ item }">
        <span>{{ getProvider(item.supplier) }}</span>
      </template>
      <template v-slot:item.associatedFile="{ item }">
        <span>{{ getAssociatedFile(item.associatedFile) }}</span>
      </template>
      <template v-slot:item.associatedBill="{ item }">
        <span>{{ getAssociatedBill(item.associatedBill) }}</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          x-small
          color="primary"
          :to="`/${path}/` + item.id"
          target="_blank"
        >
          <v-icon small>mdi-eye</v-icon>
        </v-btn>
        <v-btn
          x-small
          color="error"
          @click="deleteItem(item.id)"
          v-if="
            getCanDelete ||
            (item && getUserData && item.promoter === getUserData.id)
          "
        >
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import services from "@/services/services";
import { mapGetters, mapActions } from "vuex";
import Snackbar from "@/components/Snackbar";
export default {
  name: "Table",
  props: ["headers", "path", "values", "collection"],
  components: {
    Snackbar,
  },
  data() {
    return {
      search: "",
      provider: "",
      textError: null,
      isSnackbar: false,
      dataValue: [],
    };
  },
  methods: {
    ...mapActions(["setActionsLoader"]),
    getEvaluator(evaluator) {
      if (!evaluator) return "";
      const user = this.getObjectById("users", evaluator);
      return user ? `${user.name} ${user.surname}` : evaluator;
    },
    getPromoter(id) {
      let promoter = this.getObjectById("users", id);
      return promoter ? `${promoter.name} ${promoter.surname}` : "";
    },
    getProvider(id) {
      let supplier = this.getObjectById("clientsAndSuppliers", id);
      return supplier ? supplier.businessName : "";
    },
    getAssociatedFile(id) {
      let associatedFile = this.getObjectById("contracts", id);
      // this.provider = associatedFile
      //   ? associatedFile.awardPropJustification.providerCompany
      //   : "";
      return associatedFile
        ? associatedFile.awardPropJustification.fileName
        : "";
    },
    getAssociatedBill(id) {
      let associatedBill = this.getObjectById("invoices", id);
      return associatedBill ? associatedBill.billNumber : "";
    },
    deleteItem(id) {
      this.setActionsLoader(true);
      if (this.collection === "users") {
        services.user
          .deleteUser(id)
          .then(() => {
            this.setActionsLoader(false);
            this.textError = null;
            this.isSnackbar = true;
          })
          .catch((e) => {
            console.error(e);
            this.setActionsLoader(false);
            this.textError = "Algo salió mal. Por favor, vuelva a intentarlo";
            this.isSnackbar = true;
          });
      } else {
        services
          .deleteData(this.collection, id)
          .then(() => {
            this.setActionsLoader(false);
            this.textError = null;
            this.isSnackbar = true;
          })
          .catch((e) => {
            console.error(e);
            this.setActionsLoader(false);
            this.textError = "Algo salió mal. Por favor, vuelva a intentarlo";
            this.isSnackbar = true;
          });
      }
    },
  },
  computed: {
    ...mapGetters(["getObjectById", "getCanDelete", "getUserData"]),
  },
  watch: {
    values() {
      if (this.path === "cesupplied") {
        this.dataValue = this.values.map((item) => {
          return {
            ...item,
            searchFieldsText: `${item.suppliedNumber} ${
              item.associatedFile
                ? this.getAssociatedFile(item.associatedFile)
                : ""
            } ${this.getAssociatedBill(item.associatedBill)} ${this.getPromoter(
              item.promoter
            )} ${item.expirationDate} ${item.taxBase}`,
          };
        });
      } else if (this.path === "ceclient") {
        this.dataValue = this.values.map((item) => {
          return {
            ...item,
            searchFieldsText: `${item.businessName} ${
              item.nif
            } ${this.getPromoter(item.promoter)}`,
          };
        });
      } else {
        this.dataValue = this.values;
      }
    },
    path() {
      if (this.path === "cesupplied") {
        this.dataValue = this.values.map((item) => {
          return {
            ...item,
            searchFieldsText: `${item.suppliedNumber} ${
              item.associatedFile
                ? this.getAssociatedFile(item.associatedFile)
                : ""
            } ${this.getAssociatedBill(item.associatedBill)} ${
              item.expirationDate
            } ${item.taxBase} ${this.getPromoter(item.promoter)}`,
          };
        });
      } else if (this.path === "ceclient") {
        this.dataValue = this.values.map((item) => {
          return {
            ...item,
            searchFieldsText: `${item.businessName} ${
              item.nif
            } ${this.getPromoter(item.promoter)}`,
          };
        });
      } else {
        this.dataValue = this.values;
      }
    },
  },
  created() {
    if (this.path === "cesupplied") {
      this.dataValue = this.values.map((item) => {
        return {
          ...item,
          searchFieldsText: `${item.suppliedNumber} ${
            item.associatedFile
              ? this.getAssociatedFile(item.associatedFile)
              : ""
          } ${this.getAssociatedBill(item.associatedBill)} ${
            item.expirationDate
          } ${this.getPromoter(item.promoter)} ${item.taxBase}`,
        };
      });
    } else if (this.path === "ceclient") {
      this.dataValue = this.values.map((item) => {
        return {
          ...item,
          searchFieldsText: `${item.businessName} ${
            item.nif
          } ${this.getPromoter(item.promoter)}`,
        };
      });
    } else {
      this.dataValue = this.values;
    }
  },
};
</script>

<style></style>
